




















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ToggleableText extends Vue {
    @Prop({ default: '' }) readonly text!: string;
    @Prop({ default: 140 }) readonly maxCharacters!: number;
    @Prop({ default: '-' }) readonly placeholder!: string;

    toggle = false;

    get hideTextOverflow(): boolean {
        return !this.toggle && this.isTextOverflow;
    }

    get computedText(): string {
        return this.text && this.text.length > this.maxCharacters
            ? `${this.text.substring(0, this.maxCharacters)}...`
            : this.text;
    }

    get isTextOverflow(): boolean {
        return !!this.text && this.text.length > this.maxCharacters;
    }

    toggleFullText(): void {
        this.toggle = !this.toggle;
        this.$emit('toggled', this.toggle);
    }
}
